import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-amber-600 hover:text-amber-700 transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver a la página principal
          </Link>
        </div>
        
        <div className="bg-white rounded-xl shadow-md p-6 sm:p-8 md:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Términos y Condiciones de DogScan AI</h1>
          <p className="text-gray-600 mb-4">Última actualización: {new Date().toLocaleDateString()}</p>
          
          <div className="prose prose-amber max-w-none">
            <h2>1. Introducción</h2>
            <p>
              Bienvenido a DogScan AI. Estos Términos y Condiciones ("Términos") rigen su acceso y uso de la plataforma 
              DogScan AI, incluyendo cualquier aplicación móvil, sitio web, contenido, y servicios (colectivamente, el "Servicio") 
              ofrecidos por DogScan AI ("nosotros", "nuestro", o "la Compañía").
            </p>
            <p>
              Al acceder o utilizar nuestro Servicio, usted acepta estar sujeto a estos Términos. Si no está de acuerdo con alguna 
              parte de estos términos, no podrá acceder al Servicio.
            </p>
            
            <h2>2. Cuentas</h2>
            <p>
              Para utilizar ciertos aspectos de nuestro Servicio, es posible que deba crear una cuenta. Usted es responsable de 
              mantener la confidencialidad de su cuenta y contraseña, y acepta la responsabilidad por todas las actividades que 
              ocurran bajo su cuenta.
            </p>
            <p>
              Cuando crea una cuenta con nosotros, debe proporcionar información precisa, completa y actualizada en todo momento. 
              El incumplimiento de esto constituye una violación de los Términos, lo que puede resultar en la terminación inmediata 
              de su cuenta en nuestro Servicio.
            </p>
            
            <h2>3. Servicios de Terceros para Autenticación</h2>
            <p>
              Nuestro Servicio puede permitirle registrarse e iniciar sesión utilizando servicios de terceros como Facebook, Google, 
              o Apple. Al utilizar estos servicios, acepta cumplir con sus respectivos términos y condiciones. No somos responsables 
              de ninguna divulgación, uso o acceso a su información por parte de estos servicios de terceros, y su uso está sujeto a 
              las políticas de privacidad de estos servicios.
            </p>
            
            <h2>4. Uso Aceptable</h2>
            <p>Usted acepta no utilizar el Servicio para:</p>
            <ul>
              <li>
                Cualquier propósito que sea ilegal, dañino, fraudulento, engañoso o que viole los derechos de privacidad de otros.
              </li>
              <li>
                Publicar, cargar o distribuir cualquier contenido que sea ilegal, difamatorio, abusivo, amenazante, invasivo de 
                la privacidad, pornográfico, o que promueva el odio o la discriminación.
              </li>
              <li>
                Interferir con o dañar el funcionamiento del Servicio o los servidores o redes conectadas al Servicio.
              </li>
              <li>
                Intentar acceder a áreas del Servicio a las que no tiene permiso para acceder.
              </li>
              <li>
                Recopilar información de otros usuarios sin su consentimiento.
              </li>
            </ul>
            
            <h2>5. Propiedad Intelectual</h2>
            <p>
              El Servicio y su contenido original, características y funcionalidad son y seguirán siendo propiedad exclusiva de 
              DogScan AI y sus licenciantes. El Servicio está protegido por derechos de autor, marcas comerciales y otras leyes 
              de propiedad intelectual.
            </p>
            <p>
              Nuestras marcas y visual trade dress no pueden ser utilizadas en conexión con ningún producto o servicio sin el 
              consentimiento previo por escrito de DogScan AI.
            </p>
            
            <h2>6. Contenido del Usuario</h2>
            <p>
              Al proporcionar cualquier contenido a nuestro Servicio ("Contenido del Usuario"), usted otorga a DogScan AI una 
              licencia mundial, no exclusiva, libre de regalías, sublicenciable y transferible para usar, reproducir, modificar, 
              adaptar, publicar, traducir, crear obras derivadas, distribuir y mostrar dicho contenido en relación con 
              la operación y provisión del Servicio.
            </p>
            <p>
              Usted declara y garantiza que posee o tiene los derechos necesarios para proporcionar dicho Contenido del Usuario, 
              y que el Contenido del Usuario no infringe los derechos de propiedad intelectual de terceros.
            </p>
            
            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              En ningún caso DogScan AI, sus directores, empleados, socios, agentes, proveedores o afiliados serán responsables 
              por cualquier daño indirecto, incidental, especial, consecuente o punitivo, incluyendo, sin limitación, pérdida de 
              beneficios, datos, uso, buena voluntad, u otras pérdidas intangibles, resultantes de:
            </p>
            <ul>
              <li>
                Su acceso o uso o incapacidad para acceder o usar el Servicio.
              </li>
              <li>
                Cualquier conducta o contenido de terceros en el Servicio.
              </li>
              <li>
                Cualquier contenido obtenido del Servicio.
              </li>
              <li>
                Acceso no autorizado, uso o alteración de sus transmisiones o contenido.
              </li>
            </ul>
            
            <h2>8. Descargo de Responsabilidad</h2>
            <p>
              Su uso del Servicio es bajo su propio riesgo. El Servicio se proporciona "TAL CUAL" y "SEGÚN DISPONIBILIDAD", 
              sin garantías de ningún tipo, ya sean expresas o implícitas.
            </p>
            <p>
              DogScan AI no garantiza que el Servicio sea ininterrumpido, oportuno, seguro o libre de errores, o que el Servicio 
              cumplirá con sus requisitos o expectativas.
            </p>
            <p>
              Los consejos o información, ya sean orales o escritos, obtenidos por usted de DogScan AI o a través del Servicio, 
              no crearán ninguna garantía no expresamente establecida en estos Términos.
            </p>
            
            <h2>9. Indemnización</h2>
            <p>
              Usted acepta defender, indemnizar y mantener indemne a DogScan AI, sus afiliados, licenciantes y proveedores de servicios, 
              y sus respectivos funcionarios, directores, empleados, contratistas, agentes, licenciantes, proveedores, sucesores y 
              cesionarios de y contra cualquier reclamo, responsabilidad, daño, juicio, adjudicación, pérdida, costo, gasto o tarifa 
              (incluidos honorarios razonables de abogados) que surjan o estén relacionados con su violación de estos Términos o su 
              uso del Servicio.
            </p>
            
            <h2>10. Cambios al Servicio y a los Términos</h2>
            <p>
              DogScan AI se reserva el derecho de modificar o discontinuar, temporal o permanentemente, el Servicio (o cualquier parte del mismo) 
              con o sin previo aviso.
            </p>
            <p>
              DogScan AI se reserva el derecho de modificar estos Términos de vez en cuando. Le notificaremos de cualquier cambio 
              publicando los nuevos Términos en esta página y actualizando la fecha de "última actualización" en la parte superior 
              de estos Términos.
            </p>
            <p>
              Se le aconseja revisar estos Términos periódicamente para cualquier cambio. Los cambios a estos Términos son efectivos 
              cuando se publican en esta página.
            </p>
            
            <h2>11. Terminación</h2>
            <p>
              Podemos terminar o suspender su cuenta y acceso al Servicio inmediatamente, sin previo aviso o responsabilidad, bajo 
              nuestra sola discreción, por cualquier razón, incluyendo, sin limitación, si usted incumple estos Términos.
            </p>
            <p>
              Tras la terminación, su derecho a utilizar el Servicio cesará inmediatamente. Si desea terminar su cuenta, puede 
              simplemente discontinuar el uso del Servicio o contactarnos.
            </p>
            
            <h2>12. Ley Aplicable</h2>
            <p>
              Estos Términos se regirán e interpretarán de acuerdo con las leyes de [su jurisdicción], sin tener en cuenta 
              sus disposiciones sobre conflictos de leyes.
            </p>
            <p>
              Nuestra falta de hacer cumplir cualquier derecho o disposición de estos Términos no se considerará una renuncia a 
              esos derechos. Si alguna disposición de estos Términos es considerada inválida o inaplicable por un tribunal, las 
              disposiciones restantes de estos Términos permanecerán en vigor.
            </p>
            
            <h2>13. Contáctenos</h2>
            <p>
              Si tiene alguna pregunta sobre estos Términos, por favor contáctenos en:
            </p>
            <p className="font-medium">
              Correo electrónico: contacto@dogscanai.com<br />
              Dirección: P.º del Río 28Paseos de Taxqueña, Coyoacán, 04250 Ciudad de México, CDMX
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 